import { render, staticRenderFns } from "./roles.component.html?vue&type=template&id=4188f92c&scoped=true&external"
import script from "./roles.component.ts?vue&type=script&lang=ts&external"
export * from "./roles.component.ts?vue&type=script&lang=ts&external"
import style0 from "./roles.component.scss?vue&type=style&index=0&id=4188f92c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4188f92c",
  null
  
)

export default component.exports